// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import { DependantInputs } from './dependant_inputs_controller'
import { Dropdown } from './dropdown_controller'
import { ExtendedAutocomplete } from './extended_autocomplete_controller'
import { QuickAnswerController } from './quick_answer_controller'
import { MultiSelectFiltersController } from './multi_select_filters_controller'
import { VerifiedAddressController } from './verified_address_controller'
import { Search } from './search_controller'
import { SearchableMap } from './searchable_map_controller'
import { GeocodeableAddressableMapController } from './geocodeable_addressable_map_controller'
import { OverrideableGeocodeableAddressableMapController } from './overrideable_geocodeable_addressable_map_controller'
import { MapboxController } from './mapbox_controller'
import { SiteForm } from './site_form_controller'
import { ImagesFieldController } from './images_field_controller'
import { LocationFormController } from './location_form_controller'
import { DependentSelectsController } from './dependent_selects_controller'
import { DatePickerController } from './components/date_picker_controller'
import { DateRangePickerController } from './components/date_range_picker_controller'
import { QuickActionsController } from './components/quick_actions_controller'
import { SelectController } from './components/select_controller'
import { MultiSelectController } from './components/multi_select_controller'
import { LeftNavController } from './components/left_nav_controller'
import { RadioController } from './components/radio_controller'
import { CollapsibleAddressesController } from './collapsible_addresses_controller'
import { PubController } from './pub_controller'
import { ButtonDropdownController } from './components/button_dropdown_controller'
import { AntTableController } from './components/ant_table_controller'
import { TableTransferController } from './components/table_transfer_controller'
import { InputNumberController } from './components/input_number_controller'
import { DocumentsFieldController } from './documents_field_controller'
import { TerritoryFormController } from './territory_form_controller'
import { PaginationController } from './components/pagination_controller'
import { ToggleDisabledController } from './toggle_disabled_controller'
import { TimePickerController } from './components/time_picker_controller'
import { LabelController } from './label_controller'
import { LocationSelectController } from './location_select_controller'
import { BulkActionsController } from './bulk_actions_controller'
import { BulkActionsDropdownController } from './components/bulk_actions_dropdown_controller'
import { CountyController } from './county_controller'
import { ConfirmationModalController } from './components/confirmation_modal_controller'
import { MapWithLegendController } from './map_with_legend_controller'
import { CustomStatusCheckQuestionsController } from './custom_status_check_questions_controller'
import { CommonStatusQuestionsController } from './common_status_questions_controller'
import { ServiceOfferingTypeFormController } from './service_offering_type_form_controller'
import { ProgressBarController } from './components/progress_bar_controller'
import { StepsController } from './components/steps_controller'
import { AntIconController } from './components/ant_icon_controller'
import { AntNotificationController } from './components/ant_notification_controller'
import { ServiceOfferingRequestFormController } from './service_offering_request_form_controller'
import { PizzaTrackerController } from './pizza_tracker_controller'
import { CascaderController } from './components/cascader_controller'
import { EditDeviceFormController } from './edit_device_form_controller'
import { NewDeviceFormController } from './new_device_form_controller'
import { StaticMapController } from './static_map_controller'
import { CarouselController } from './carousel_controller'
import { PhotoswipeController } from './photoswipe_controller'
import { EquipmentTypeCardController } from './equipment_type_card_controller'
import { ConfirmableNavigationController } from './components/confirmable_navigation_controller'
import { ServiceOfferingFormController } from './service_offering_form_controller'
import { TurboModalController } from './components/turbo_modal_controller'
import { FullCheckController } from './full_check_controller'
import { DeclineFormController } from './decline_form_controller'
import { DeviceShowController } from './device_show_controller'
import { QRCodeController } from './components/qr_code_controller'
import { VerticalTransferController } from './components/vertical_transfer_controller'
import { AntTableBulkActionsController } from './ant_table_bulk_actions_controller'
import { TooltipController } from './tooltip_controller'
import { DispatcherController } from './dispatcher_controller'
import { UsageEventFormController } from './usage_event_form_controller'
import { UsageEventMapController } from './usage_event_map_controller'
import { UsageEventOrganizationController } from './usage_event_organization_controller'
import { NestedFormController } from './nested_form_controller'
import { ValidateFormController } from './validate_form_controller'
import { SupportingDocumentController } from './supporting_document_controller'
import { EquipmentCardController } from './equipment_card_controller'
import { FileUploadController } from './components/file_upload_controller'
import { InvoiceTableController } from './invoice_table_controller'
import { VarianceFormController } from './variance_form_controller'
import { TimeWithoutTimeZonePickerController } from './components/time_without_time_zone_picker_controller'
import { InvoiceFormController } from './invoice_form_controller'

application.register('mapbox', MapboxController)
application.register('autocomplete', ExtendedAutocomplete)
application.register('dependant-inputs', DependantInputs)
application.register('dropdown', Dropdown)
application.register('quick-answer', QuickAnswerController)
application.register('multi-select-filters', MultiSelectFiltersController)
application.register('verified-address', VerifiedAddressController)
application.register('search', Search)
application.register('searchable-map', SearchableMap)
application.register(
  'geocodeable-addressable-map',
  GeocodeableAddressableMapController,
)
application.register(
  'overrideable-geocodeable-addressable-map',
  OverrideableGeocodeableAddressableMapController,
)
application.register('site-form', SiteForm)
application.register('images-field', ImagesFieldController)
application.register('date-picker', DatePickerController)
application.register('date-range-picker', DateRangePickerController)
application.register('time-picker', TimePickerController)
application.register('quick-actions', QuickActionsController)
application.register('select', SelectController)
application.register('multi-select', MultiSelectController)
application.register('location-form', LocationFormController)
application.register('location-select', LocationSelectController)
application.register('left-nav', LeftNavController)
application.register('radio', RadioController)
application.register('dependent-selects', DependentSelectsController)
application.register('collapsible-addresses', CollapsibleAddressesController)
application.register('pub', PubController)
application.register('button-dropdown', ButtonDropdownController)
application.register('ant-table', AntTableController)
application.register('table-transfer', TableTransferController)
application.register('input-number', InputNumberController)
application.register('documents-field', DocumentsFieldController)
application.register('territory-form', TerritoryFormController)
application.register('pagination', PaginationController)
application.register('toggle-disabled', ToggleDisabledController)
application.register('label', LabelController)
application.register('county', CountyController)
application.register('bulk-actions', BulkActionsController)
application.register('bulk-actions-dropdown', BulkActionsDropdownController)
application.register('confirmation-modal', ConfirmationModalController)
application.register('map-with-legend', MapWithLegendController)
application.register(
  'custom-status-check-questions',
  CustomStatusCheckQuestionsController,
)
application.register('common-status-questions', CommonStatusQuestionsController)
application.register(
  'service-offering-type-form',
  ServiceOfferingTypeFormController,
)
application.register('progress-bar', ProgressBarController)
application.register('steps', StepsController)
application.register('ant-icon', AntIconController)
application.register('ant-notification', AntNotificationController)
application.register(
  'service-offering-request-form',
  ServiceOfferingRequestFormController,
)
application.register('pizza-tracker', PizzaTrackerController)
application.register('cascader', CascaderController)
application.register('edit-device-form', EditDeviceFormController)
application.register('new-device-form', NewDeviceFormController)
application.register('static-map', StaticMapController)
application.register('carousel', CarouselController)
application.register('photoswipe', PhotoswipeController)
application.register('equipment-type-card', EquipmentTypeCardController)
application.register('confirmable-navigation', ConfirmableNavigationController)
application.register('service-offering-form', ServiceOfferingFormController)
application.register('turbo-modal', TurboModalController)
application.register('full-check', FullCheckController)
application.register('decline-form', DeclineFormController)
application.register('device-show', DeviceShowController)
application.register('qr-code', QRCodeController)
application.register('ant-table-bulk-actions', AntTableBulkActionsController)
application.register('vertical-transfer', VerticalTransferController)
application.register('tooltip', TooltipController)
application.register('dispatcher', DispatcherController)
application.register('usage-event-form', UsageEventFormController)
application.register('usage-event-map', UsageEventMapController)
application.register(
  'usage-event-organization',
  UsageEventOrganizationController,
)
application.register('nested-form', NestedFormController)
application.register('supporting-document-form', SupportingDocumentController)
application.register('validate-form', ValidateFormController)
application.register('equipment-card', EquipmentCardController)
application.register('file-upload', FileUploadController)
application.register('invoice-table', InvoiceTableController)
application.register('variance-form', VarianceFormController)
application.register(
  'time-without-time-zone-picker',
  TimeWithoutTimeZonePickerController,
)
application.register('invoice-form', InvoiceFormController)
